module.exports = "﻿﻿<div class=\"row wrapper border-bottom white-bg page-heading\">\r\n    <div class=\"col-lg-6\">\r\n        <h2>Thank you</h2>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"wrapper wrapper-content animated fadeInRight\">\r\n    <div class=\"row\">\r\n        <p>Please call us on 01902 712191 and we will take payment over the phone to upgrade your account. If you have any questions, we’re here to help. </p>\r\n\r\n        <p><a [routerLink]=\"['/account/subscriptions']\">To view your invoice, please click here.</a></p>\r\n\r\n    </div>\r\n    \r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/subscription/phone.component.html
// module id = 1226
// module chunks = 0